'use strict';

const gridTokens = (theme) => ({
    gridGapX: theme.space.component.x.m,
    gridGapY: theme.space.component.x.m,
    gridWrapperPaddingX: theme.space.component.x.l,
});

exports.gridTokens = gridTokens;
//# sourceMappingURL=grid.js.map
